import { render, staticRenderFns } from "./MineUnitCard.vue?vue&type=template&id=21aa10ba"
import script from "./MineUnitCard.vue?vue&type=script&lang=js"
export * from "./MineUnitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports